"use strict";
exports.__esModule = true;
exports.LegendLabelItem = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
exports.LegendLabelItem = function (props) {
    var label = props.label;
    if (!label) {
        return null;
    }
    return (react_1["default"].createElement("div", { className: "series-item" },
        react_1["default"].createElement("div", { className: "series-name" }, label + ":")));
};
//# sourceMappingURL=LegendLabelItem.js.map